import { render, staticRenderFns } from "./Create-Supplier.vue?vue&type=template&id=84b22e7c&scoped=true"
import script from "./Create-Supplier.vue?vue&type=script&lang=js"
export * from "./Create-Supplier.vue?vue&type=script&lang=js"
import style0 from "./Create-Supplier.vue?vue&type=style&index=0&id=84b22e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b22e7c",
  null
  
)

export default component.exports